const render = ({plc_id}) => {
    return `
    <!-- ADSMITH SURVEY START -->
    <div id="AS_SURVEY"></div>
    <script type="application/javascript">
    // ADSMITH SETTINGS
      var as_plc_id = '${plc_id}';
      // USER DATA
      
      var as_email = '{email}';
      var as_fname = '{firstName}';
      var as_lname = '{lastName}';
      var as_gender = '{gender}';
      var as_phone_1 = '{phone_areaCode}';
      var as_phone_2 = '{phone_prefix}';
      var as_phone_3 = '{phone_suffix}';
      var as_addy_street = '{address1}';
      var as_addy_line_2 = '{address2}';
      var as_addy_city = '{city}';
      var as_addy_state = '{state}';
      var as_addy_zip = '{zip}';
      var as_dob_y = '{dob_yyyy}';
      var as_dob_m = '{dob_mm}';
      var as_dob_d = '{dob_dd}';
      var as_subid_a = '{pe_key}';
      var as_home_status = '';
      // 3RD PARTY VALIDATION
      var as_trusted_form = '';
      var as_jn_lead_id = '';
      // PUBLISHER SETTINGS
      var as_furl = '{nextURL}';
    </script>
    <script src="//www.adsmith.io/load-survey.js"></script>
    <!-- ADSMITH SURVEY END -->
    `.trim()
  };
  
  export default render;